import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import { createSelector } from 'reselect';

import { Helmet } from 'react-helmet';

import List from './List/List';
import NoBuildings from './NoBuildings';
import News from './News';
import Dropdown from 'components/common/Dropdown';
import Menu from 'components/common/Menu';
import iconMap from 'assets/images/icons/icon-search-map.svg';
import iconList from 'assets/images/icons/list.svg';
import iconCross from 'assets/images/icons/close.svg';

import cn from 'classnames';
import styles from './Buildings.scss';

import { pluralize, parseQuery, compileQuery } from 'utils';

import { getRequest } from '../Header/FiltersBar/Filters/Filters';
import { changeFilters } from 'actions/search';
import TypeFilters from 'components/TypeFilters';

import { loadData } from 'actions/objects';
import withValidTrafic from 'decorators/withValidTrafic';
import withObservePayments from 'decorators/withObservePayments';
import MainMap from './YMap';
import tracker from '../../services/tracker';
import i18n from '../../i18n';
import { withTranslation } from 'react-i18next';

// {t('components.buildings.filterLabel.blackList')}
const sorts = {
  'date_update DESC': {
    text: i18n.t('components.buildings.buildings.sorts.date_updateDESC'),
    orderField: 'date_update',
    orderDirection: 'DESC',
    key: 'dateDesc',
    event: 'Web_Sort_Date'
  },
  'cost_min ASC': {
    text: i18n.t('components.buildings.buildings.sorts.cost_minASC'),
    orderField: 'cost_min',
    orderDirection: 'ASC',
    key: 'costAsc',
    event: 'Web_Sort_Price_Cheaper'
  },
  'cost_min DESC': {
    text: i18n.t('components.buildings.buildings.sorts.cost_minDESC'),
    orderField: 'cost_min',
    orderDirection: 'DESC',
    key: 'costDesc',
    event: 'Web_Sort_Price_Expensive'
  },
  'title ASC': {
    text: i18n.t('components.buildings.buildings.sorts.title'),
    orderField: 'title',
    orderDirection: 'ASC',
    key: 'titleAsc',
    event: 'Web_Sort_Title'
  }
  // 'visit_day DESC': {
  //   text: 'день',
  //   orderField: 'visit_day',
  //   orderDirection: 'DESC',
  //   key: 'visit_day'
  // },
  // 'visit_week DESC': {
  //   text: 'неделя',
  //   orderField: 'visit_week',
  //   orderDirection: 'DESC',
  //   key: 'visit_week'
  // },
  // 'visit_month DESC': {
  //   text: 'месяц',
  //   orderField: 'visit_month',
  //   orderDirection: 'DESC',
  //   key: 'visit_month'
  // }
};

const getSort = (query) => {
  const { view } = query;
  if (!view || view === 'map') {
    return {};
  }

  const sortKey = Object.keys(sorts).find((key) => (sorts[key].key === view));
  if (!sortKey) {
    return {};
  }

  const sort = sorts[sortKey];
  const { orderField, orderDirection } = sort;
  return { orderField, orderDirection };
};

const sortKeys = Object.keys(sorts);

const typeFilters = ['nedvex', 'new', 'viewAction', 'orderField', 'blackList'];
const newOrderFields = ['visit_day', 'visit_week', 'visit_month'];
const typeFiltersInfo = [
  {
    key: 'nedvex',
    text: i18n.t('components.buildings.buildings.typeFiltersInfo.nedvex')
  },
  {
    key: 'new',
    text: i18n.t('components.buildings.buildings.typeFiltersInfo.nedvex')
  },
  {
    key: 'viewAction',
    text: i18n.t('components.buildings.buildings.typeFiltersInfo.promo')
  },
  {
    key: 'orderField',
    text: i18n.t('components.buildings.buildings.typeFiltersInfo.orderField')
  }
];

const getFilterTypeByRequest = (request) => {
  const filter = Object.keys(request).filter(k => {
    if (request[k]) {
      if (typeFilters.includes(k)) {
        if (k === 'orderField') {
          if (newOrderFields.includes(request[k])) return true;
          return false;
        }
        return true;
      }
    }
  })[0];
  return typeFiltersInfo.find(info => info.key === filter);
};

@withObservePayments
@withValidTrafic()
class Buildings extends Component {
  constructor(props) {
    super(props);

    this.handleListToggleClick = this.handleListToggleClick.bind(this);
    this.handleSortClick = this.handleSortClick.bind(this);
    this.handleResetFiltersClick = this.handleResetFiltersClick.bind(this);
    this.state = {
      containerHeight: 1000
    };
  }
  UNSAFE_componentWillMount() {
    document.body.classList.toggle('index', true);
  }
  componentDidMount() {
    const { objects: { ui }, dispatch } = this.props;
    // if (!ui.scrollTop) {
    this.getStateFromSearch();
    // }

    tracker.sendEventOnce('Web_Launch_First_Time');
    window.onpopstate = this.handleBackButton;
    window.addEventListener('resize', this.handleResize);
    document.getElementsByTagName('html')[0].classList.toggle('objectsListPage', true);
  }

  componentWillUnmount() {
    document.getElementsByTagName('html')[0].classList.remove('objectsListPage');
    window.removeEventListener('resize', this.handleResize);
    document.body.classList.toggle('index', false);
  }

  getStateFromSearch = () => {
    const { dispatch, request: initialRequest, location, changeFilters } = this.props;
    const query = parseQuery(location.search);
    const isPopularFilter = query.orderField ? newOrderFields.includes(query.orderField) : false;

    if (isPopularFilter) {
      const request = { ...initialRequest, ...getRequest(query), orderDirection: 'DESC' };
      changeFilters(request);
    } else {
      const request = { ...initialRequest, ...getRequest(query), ...getSort(query) };
      changeFilters(request);
    }
  }

  handleBackButton = () => {
    this.getStateFromSearch();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const { location: { search }, request, isCottegesPage } = nextProps;
    const { location: { search: prevSearch }, request: prevRequest, location, dispatch } = this.props;
    const v1 = parseQuery(search).view;
    const v2 = parseQuery(prevSearch).view;
    this.setState({ isCottegesPage: !!isCottegesPage });

    if ((request !== prevRequest || v1 !== v2 || isCottegesPage !== this.props.isCottegesPage)) {
      try {
        const city = this.props.cities.find(cities => cities.id === nextProps.cityId);
        const region = city ? city.regions.map(({ id }) => id) : null;
        dispatch(loadData(this.isList(search), { ...request, limit: request.limit || 10, typeId: location.pathname.includes('cottages') ? 2 : 1, region: request.region || region }, true));
        document.body.scrollTop = 0;
      } catch (e) {
        console.log(e);
      }
    }
  }

  isList(search) {
    const { location } = this.props;
    const query = parseQuery(search || location.search);
    return !query.view || query.view !== 'map';
  }

  handleListToggleClick() {
    const { location, history } = this.props;
    const { search } = location;
    let view;
    if (this.isList()) {
      tracker.sendEvent('Web_Map');
      view = 'map';
    } else {
      const { request: { orderField, orderDirection } } = this.props;
      tracker.sendEvent('Web_Map_Object_List');
      view = sorts[`${orderField} ${orderDirection}`].key;
    }
    const query = compileQuery({ view }, search);
    history.push(`/${location.pathname.includes('cottages') ? 'cottages' : ''}?${query}`);
  }

  handleSortClick(orderField, orderDirection) {
    const sort = sorts[`${orderField} ${orderDirection}`];
    const { location, history } = this.props;
    const { search } = location;
    const query = compileQuery({ view: sort.key }, search);

    if (sort.event) {
      tracker.sendEvent(sort.event);
    }

    history.push(`/${location.pathname.includes('cottages') ? 'cottages' : ''}?${query}`);

    const { changeFilters } = this.props;
    changeFilters({ orderField, orderDirection });
  }

  handleResetFiltersClick() {
    const { location, history, resetFilters } = this.props;
    const { pathname } = location;
    const path = `${pathname}`;
    history.push(path);
    resetFilters();
  }

  renderControls = (isList, hasFilters, total, sortKey) => {
    const { isCottegesPage } = this.state;
    const { t } = this.props;
    return (
      <div className={cn(styles.Controls, { [styles.OverMap]: !isList })} key="controls">
        {isList &&
          <div className={styles.SearchTitle}>
            <p>
              {hasFilters ? t('components.buildings.buildings.searchResults') : isCottegesPage ? t('components.buildings.buildings.cottegesPage') : t('components.buildings.buildings.new')}
              {hasFilters ? <button className={styles.ResetAllFilters} onClick={this.handleResetFiltersClick}>
                <img src={iconCross} /> {t('components.buildings.buildings.clear')} <span className={styles.Hide1080}>{t('components.buildings.buildings.filters')}</span></button> : null}
            </p>

            <small>{`${pluralize(total, t('components.buildings.buildings.search1'), t('components.buildings.buildings.search2'), t('components.buildings.buildings.search3'))} ${total || '0'}
              ${!isCottegesPage ? pluralize(total, t('components.buildings.buildings.new1'), t('components.buildings.buildings.new2'), t('components.buildings.buildings.new3')) :
              pluralize(total, t('components.buildings.buildings.object1'), t('components.buildings.buildings.object2'), t('components.buildings.buildings.object3'))}`}</small>
          </div>
        }
        <div className={styles.Order}>
          <p className={styles.PreOrderText}>
            {t('components.buildings.buildings.by')}
          </p>
          <Dropdown
            className={cn(styles.Dropdown)}
            buttonStyle={styles.DropdownButton}
            textStyle={styles.DropdownText}
            iconStyle={styles.DropdownIcon}
            text={sorts[sortKey].text}
            data-tip={t('components.buildings.buildings.sortList')}
            data-for="tooltip"
            topShift
          >
            <Menu rightArrow pure>
              <div className={styles.OrderMenu}>
                {sortKeys.map((key) => {
                  const sort = sorts[key];
                  const { orderField, orderDirection } = sort;
                  return (
                    <div
                      key={key}
                      className={cn(styles.OrderMenuItem, { [styles.OrderMenuActive]: key === sortKey })}
                      onClick={this.handleSortClick.bind(undefined, orderField, orderDirection)}
                    >
                      <span>{sort.text}</span>
                    </div>
                  );
                })}
              </div>
            </Menu>
          </Dropdown>
          <div className={styles.SwitcherWrapper}>
            <button
              className={styles.OpenMapBtn}
              onClick={this.handleListToggleClick}
            >
              {isList ? (<img src={iconMap} alt="" />) : (<img src={iconList} alt="" />)}
              {isList ? (
                <span>
                  <span className={styles.Hide1024}>

                    {t('components.buildings.buildings.searchOnMap')}
                  </span>
                  <span className={styles.Show1024}>
                    {t('components.buildings.buildings.onMap')}
                  </span>
                </span>
              ) : t('components.buildings.buildings.searchOnList')}
            </button>
          </div>
        </div>
      </div>
    );
  }

  getFilters = (filters, request) => {
    const { location, history, changeFilters } = this.props;
    const { pathname, search } = location;
    const query = compileQuery(filters, search);
    const newSearch = query ? `?${query}` : '';
    const path = `${pathname}${newSearch}`;
    history.push(path);
    changeFilters(request);
  }

  renderTypeFiltersControls = ({ isList, request, total, sortKey }) => {
    const { t } = this.props;
    const { isCottegesPage } = this.state;
    const filter = getFilterTypeByRequest(request);
    const { key, text } = filter;
    const isOrderField = key === 'orderField';
    const isBlackList = key === 'blackList';
    const isNew = key === 'new';
    const isAction = key === 'viewAction';
    const { orderField } = request;

    return (
      <div className={cn(styles.Controls, { [styles.OverMap]: !isList })} key="controls">
        {isList &&
          <div className={cn(styles.SearchTitle, (isOrderField && styles.IsOrderField))}>
            <p>
              {text}
            </p>
            {!isOrderField ?
              <small>
                {
                    `${!isOrderField ? `${pluralize(total, t('components.buildings.buildings.search1'), t('components.buildings.buildings.search2'), t('components.buildings.buildings.search3'))}` : ''
                    } ${total || '0'} ${!isCottegesPage ?
                      pluralize(total, t('components.buildings.buildings.new1'), t('components.buildings.buildings.new2'), t('components.buildings.buildings.new3')) :
                    pluralize(total, t('components.buildings.buildings.object1'), t('components.buildings.buildings.object2'), t('components.buildings.buildings.object3'))}`
                  }
              </small>
                :
            null}
          </div>
        }
        <div className={styles.Order}>
          {isOrderField &&
            <div className={styles.OrderButtons}>
              <div
                className={cn(styles.OrderBtn, (orderField === 'visit_day' && styles.Active))}
                onClick={() => this.getFilters({ orderField: 'visit_day' }, { orderField: 'visit_day' })}
              >
                {t('components.buildings.buildings.day')}
              </div>
              <div
                className={cn(styles.OrderBtn, (orderField === 'visit_week' && styles.Active))}
                onClick={() => this.getFilters({ orderField: 'visit_week' }, { orderField: 'visit_week' })}
              >
                {t('components.buildings.buildings.week')}
              </div>
              <div
                className={cn(styles.OrderBtn, (orderField === 'visit_month' && styles.Active))}
                onClick={() => this.getFilters({ orderField: 'visit_month' }, { orderField: 'visit_month' })}
              >
                {t('components.buildings.buildings.month')}
              </div>
            </div>
          }
          {/* {isBlackList && <div className={styles.BlacklistDescrip}>Список новостроек, <a href="https://www.sochiadm.ru/blacklist/" target="_blank">признанных администрацией г. Сочи <br />объектами самовольного строительства</a></div>} */}
        </div>
      </div>
    );
  }

  renderData(objects, request, hasFilters, dispatch, pathname) {
    const { isTypeFilters, isOrderFieldTypeFilter } = this.props;
    const { ui, points } = objects;
    const isList = this.isList();
    const { data, total } = isList ? objects.objects : objects.pins;
    const { orderField, orderDirection } = request;
    const sortKey = `${orderField} ${orderDirection}`;
    const isAction = request.viewAction === 'true';

    return (
      <div className={styles.ObjectsInner} ref={this.getScrollContainer}>
        {/* <Loader active={ui.isInfiniteLoading || isMapLoading} /> */}
        {!isList ?
          isTypeFilters ?
            this.renderTypeFiltersControls({ isList, total, request, sortKey })
            :
            this.renderControls(isList, hasFilters, total, sortKey)
          :
          null
        }
        {isList ?
          <List
            dispatch={dispatch}
            scrollTop={ui.scrollTop}
            isFinished={ui.isFinished || isOrderFieldTypeFilter}
            isInfiniteLoading={ui.isInfiniteLoading}
            isTypeFilterAction={isAction}
            request={request}
            data={data}
            containerHeight={this.state.containerHeight}
            scrollContainer={this.scrollContainer}
            isCottegesPage={this.state.isCottegesPage}
          >
            <TypeFilters isCottegesPage={this.state.isCottegesPage} />
            {isTypeFilters ?
              this.renderTypeFiltersControls({ isList, total, request, sortKey })
              :
              this.renderControls(isList, hasFilters, total, sortKey)
            }
          </List>
        :
        data && <MainMap dispatch={dispatch} data={data} points={points} />
        }
      </div>
    );
  }

  handleResize = () => {
    if (this.scrollContainer) {
      this.setState({
        containerHeight: this.scrollContainer.clientHeight
      });
    }
  }

  getScrollContainer = (ref) => {
    this.scrollContainer = ref;
    this.handleResize();
  }

  render() {
    const { className, dispatch, pathname, request, objects, hasFilters, withClient, t } = this.props;
    const isList = this.isList();
    const { data } = isList ? objects.objects : objects.pins;
    return (
      <React.Fragment>
        <Helmet>
          <title>{`${hasFilters ? t('components.buildings.buildings.searchResults') : t('components.buildings.buildings.newShort')}${isList ? '' : ` - ${t('components.buildings.buildings.map')}`} - Nedvex`}</title>
        </Helmet>
        <div className={cn(styles.Wrapper, withClient && styles.withClient)}>
          <div className={cn(styles.Objects, className)}>
            {data && data.length === 0 ? (
              <NoBuildings dispatch={dispatch} />
              ) : (
                this.renderData(objects, request, hasFilters, dispatch, pathname)
              )}
          </div>
          {!withClient && <News />}
        </div>
      </React.Fragment>
    );
  }
}

const getBuildings = createSelector(
  state => state.objects,
  state => state.search.request,
  state => state.search.hasFilters,
  state => state.privacy.withClient,
  state => state.search.isTypeFilters,
  state => state.search.isOrderFieldTypeFilter,
  state => state.profile.cityId,
  state => state.building.cities,
  (objects, request, hasFilters, withClient, isTypeFilters, isOrderFieldTypeFilter, cityId, cities) => ({
    objects,
    request,
    hasFilters,
    withClient,
    isTypeFilters,
    isOrderFieldTypeFilter,
    cityId,
    cities
  })
);

const mapDispatchToProps = (dispatch) => ({
  changeFilters: (filters) => dispatch(changeFilters(filters)),
  resetFilters: () => dispatch(changeFilters(null, { reset: true })),
  dispatch
});

const mergeProps = (stateProps, dispatchProps, otherProps) => {
  const changeFilters = (filters) => {
    if (otherProps.isCottegesPage) {
      dispatchProps.changeFilters({ ...filters, typeId: 2 });
    } else {
      dispatchProps.changeFilters({ ...filters, typeId: 1 });
    }
  };

  return {
    ...stateProps,
    ...dispatchProps,
    ...otherProps,
    changeFilters
  };
};

export default connect(getBuildings, mapDispatchToProps, mergeProps)(
  withRouter(withTranslation()(Buildings))
);



// WEBPACK FOOTER //
// ./src/components/Buildings/Buildings.js